//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtArrowLink from './MtArrowLink'
export default {
  components: {
    MtArrowLink
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCookieMessage: !this.$cookies.get('acceptCookies') && this.$cookies.get('boardingShown')
    }
  },
  computed: {
  },
  methods: {
    hide () {
      this.$cookies.set('acceptCookies', true)
      this.showCookieMessage = false
      this.$emit('dismiss')
    }
  }
}
